export default {
    "navigation": {
        "allWatchfaces": "모든 앱",
        "faq": "FAQ",
        "helpCenter": "도움말 및 설명",
        "newsletter": "뉴스레터",
        "contact": "문의",
        "weatherProvider": "날씨 제공자",
        "tides": "조수",
        "colors": "색상",
        "fonts": "글꼴"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "모든 활동을 위한 고급 기능을 갖춘 현대적인 Garmin 앱",
        "newBadge": "신규",
        "filter": {
            "label": "Product filter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "noProducts": "No products in this category"
        }
    },
    "faq": {
        "title": "자주 묻는 질문",
        "subtitle": "워치페이스에 대한 일반적인 질문의 답변을 찾아보세요",
        "tabs": {
            "search": "검색",
            "categories": "카테고리",
            "trending": "트렌딩"
        },
        "search": {
            "placeholder": "도움말 검색...",
            "button": "검색",
            "suggestions": "인기 검색어",
            "tips": {
                "title": "검색 팁",
                "keywords": "\"GPS\", \"날씨\", \"설정\"과 같은 구체적인 키워드를 사용하세요",
                "language": "검색은 선택한 언어로 작동합니다",
                "categories": "정리된 도움말을 위해 카테고리를 탐색하세요"
            }
        },
        "noResults": {
            "title": "결과를 찾을 수 없습니다",
            "description": "다른 키워드를 시도하거나 카테고리를 탐색하세요",
            "browseCategories": "카테고리 탐색"
        },
        "suggestions": {
            "title": "인기 검색어"
        },
        "trending": {
            "title": "트렌딩 검색어"
        },
        "categories": {
            "title": "카테고리별 탐색",
            "items": "항목",
            "allItems": "모든 FAQ 항목",
            "allItemsDescription": "모든 자주 묻는 질문을 탐색하세요",
            "noItems": {
                "title": "이 카테고리에 항목이 없습니다",
                "description": "다른 카테고리를 선택해보세요"
            },
            "viewMore": "모든 항목 보기"
        },
        "results": {
            "title": "검색 결과",
            "found": "개의 결과를 찾았습니다",
            "total": "총 결과",
            "bestMatch": "최고 일치",
            "categories": "카테고리",
            "sortBy": "정렬 기준",
            "sort": {
                "relevance": "관련성",
                "priority": "우선순위",
                "category": "카테고리"
            },
            "lastUpdated": "마지막 업데이트",
            "matchedIn": "일치 위치",
            "footer": "찾고 있던 것을 찾지 못했나요?",
            "browseCategories": "카테고리 탐색",
            "viewTrending": "트렌딩 보기",
            "contactSupport": "지원팀 문의"
        },
        "actions": {
            "copy": "복사",
            "share": "공유",
            "copyAnswer": "답변 복사",
            "copyAll": "모두 복사"
        },
        "loading": "FAQ 로딩 중...",
        "error": "로딩 오류",
        "retry": "다시 시도"
    },
    "guides": {
        "backToHelp": "뒤로",
        "purchase": {
            "title": "구매 및 설치",
            "tabs": {
                "installation": "설치",
                "versions": "VX / Elite 버전",
                "troubleshooting": "문제 해결"
            },
            "installation": {
                "title": "ConnectIQ 앱으로 워치페이스 설치",
                "intro": "워치페이스는 Android 또는 iOS용 Garmin ConnectIQ 앱을 통해 워치에 설치할 수 있습니다.",
                "step1": "워치를 Bluetooth로 휴대폰에 연결하고 휴대폰에서 ConnectIQ 앱을 엽니다.",
                "step2": "설치하려는 워치페이스 페이지로 이동합니다.",
                "step3": "\"설치\" 버튼을 탭합니다. 워치페이스가 다운로드 대기열에 추가되어 워치에 설치됩니다.",
                "step4": "설치 후 앱 또는 워치에 메시지가 표시되고 워치페이스를 사용할 수 있습니다.",
                "noteScreen": "설치 및 업데이트 중에는 휴대폰 화면이 꺼지지 않고 ConnectIQ 앱이 열린 상태를 유지하세요.",
                "selectWatchfaceTitle": "워치에서 워치페이스 선택",
                "selectWatchfaceIntro": "워치페이스가 설치되었지만 아직 보이지 않으면 워치 시스템 메뉴에서 선택해야 할 수 있습니다.",
                "select1": "워치의 메뉴 버튼을 길게 누르세요(또는 터치스크린 기기에서는 해당 버튼)하여 시스템 메뉴를 엽니다.",
                "select2": "\"워치 페이스\" 또는 \"디스플레이 디자인\" 메뉴 항목으로 이동합니다.",
                "select3": "설치된 모든 워치페이스 목록이 표시됩니다. 위/아래 버튼 또는 터치스크린으로 이동합니다.",
                "select4": "오른쪽 위 버튼으로 선택한 워치페이스를 확인합니다. 워치페이스가 워치에서 활성화됩니다."
            },
            "versions": {
                "title": "VX와 Elite의 차이점은?",
                "sameFeatures": "기술적으로 두 버전은 동일하며 동일한 기능을 제공합니다. 차이점은 구매 및 활성화 방식뿐입니다.",
                "eliteTitle": "Elite 버전(Garmin Pay)",
                "elite1": "ConnectIQ 스토어에서 Garmin Pay로 직접 구매한 워치페이스의 별도 설치.",
                "elite2": "Elite 버전은 Garmin 계정에 연결됩니다. 새 워치를 구매해도 추가 키 없이 Elite 워치페이스를 다시 설치할 수 있습니다.",
                "elite3": "Garmin Pay는 모든 워치 모델에서 지원되지 않으며 모든 국가에서 사용 가능하지 않을 수 있습니다.",
                "eliteNoKey": "중요: Garmin Pay로 Elite 버전을 구매하면 잠금 해제 코드가 전송되지 않습니다. Elite 버전은 구매 후 즉시 잠금 해제되며 코드가 필요하지 않습니다.",
                "vxTitle": "VX / 웹사이트 버전",
                "vx1": "더 많은 기기와 호환되며 Garmin Pay를 사용할 수 없을 때도 사용 가능한 경우가 많습니다.",
                "vx2": "며칠간의 무료 체험 기간이 포함되어 있습니다.",
                "vx3": "체험 후 이 웹사이트에서 잠금 해제 코드를 구매하여 VX 버전(또는 프로 기능)을 영구적으로 잠금 해제할 수 있습니다.",
                "vx4": "잠금 해제 코드는 구매한 기기(WatchfaceID)에만 유효합니다.",
                "vx5": "워치가 Garmin 보증으로 교체된 경우 새 키를 생성할 수 있습니다. 해당 경우 문의 양식을 통해 지원팀에 연락하세요."
            },
            "website": {
                "title": "웹사이트 구매(VX / 일반 버전)",
                "step1": "먼저 워치에 워치페이스를 설치하세요(설치 탭 참조). WatchfaceID는 설치 후에만 워치페이스 설정에 표시됩니다.",
                "step2": "워치페이스 설정을 엽니다(ConnectIQ 앱 또는 Garmin Express 통해). 상단 필드에서 WatchfaceID를 복사합니다.",
                "step3": "이 웹사이트에서 해당 워치페이스를 선택하고 구매 양식에 WatchfaceID를 입력합니다.",
                "step4": "결제를 완료합니다. 이메일로 잠금 해제 코드를 받으며 워치페이스 설정의 키 필드에 입력할 수 있습니다.",
                "noteNoAutoInstall": "중요: 웹사이트를 통해 잠금 해제 코드를 구매해도 워치에 워치페이스가 자동으로 설치되지 않습니다. 위 설치 단계를 수동으로 완료해야 합니다."
            },
            "troubleshooting": {
                "installationTitle": "설치 문제(대기열 / 업데이트 멈춤)",
                "installationIntro": "가끔 설치가 실패하거나 워치페이스가 오랫동안 대기열에 있거나 ConnectIQ 앱이 끝없는 업데이트를 보고합니다.",
                "installationCause": "이는 일반적으로 워치페이스 자체가 아니라 ConnectIQ 앱 또는 Garmin 서비스와 관련이 있습니다.",
                "installationFix1": "워치를 재시작하고 휴대폰의 ConnectIQ 앱을 재시작하세요.",
                "installationFix2": "설치를 다시 시도하고 과정 중 휴대폰 화면이 꺼지지 않고 ConnectIQ 앱이 열린 상태를 유지하세요.",
                "garminPayTitle": "Garmin Pay 구매가 \"진행 중\"에서 멈춤",
                "garminPayText": "ConnectIQ 스토어에서 Garmin Pay 구매가 오랫동안 \"진행 중\" 상태로 있으면 Garmin이 전적으로 처리합니다. 개발자로서 Garmin Pay 시스템에 영향을 줄 수 없습니다. 해당 경우 Garmin 공식 지원에 문의하세요.",
                "noKeyTitle": "웹사이트 구매 후 잠금 해제 키를 받지 못함",
                "noKey1": "먼저 이메일 받은편지함의 스팸 폴더를 확인하세요. 키가 포함된 이메일이 거기 들어가는 경우가 많습니다.",
                "noKey2": "이메일 주소 오타로 인해 전달이 안 되는 경우가 많습니다. 이메일을 찾을 수 없으면 문의해 주세요.",
                "noKey3": "결제에 사용한 이메일 주소와 가능하면 WatchfaceID를 포함하세요.",
                "noKeyElite": "참고: ConnectIQ 스토어에서 Garmin Pay로 Elite 버전을 직접 구매한 경우 잠금 해제 코드가 전송되지 않습니다. Elite 버전은 구매 후 즉시 잠금 해제되며 코드가 필요하지 않습니다."
            },
            "contactLink": "문의 양식"
        },
        "timezones": {
            "title": "타임존 및 UTC 오프셋",
            "basicsTitle": "제2·제3 타임존이란?",
            "basicsText": "많은 워치페이스에서 두 개의 추가 타임존을 설정할 수 있습니다. 일반적으로 \"제2 타임존\"과 \"제3 타임존\"이라고 하며 워치페이스의 전용 필드에 표시됩니다.",
            "offsetTitle": "UTC 오프셋 설정",
            "offsetIntro": "워치페이스 설정에는 일반적으로 제2·제3 타임존의 UTC 대비 분 단위 오프셋을 입력할 수 있는 필드가 있습니다.",
            "offsetFormat": "첫 번째 값이 제2 타임존 오프셋, 두 번째 값이 제3 타임존 오프셋입니다. 값은 분 단위이며 공백으로 구분합니다. + 기호는 자동으로 붙지 않으므로 양수는 + 없이 입력합니다.",
            "exampleLabel": "예:",
            "exampleExplanation": "여기서 제2 타임존은 -4.5시간(−270분), 제3 타임존은 +2시간(+120분) 오프셋을 사용하며 항상 UTC 기준입니다.",
            "changeExample": "제2 타임존을 +6시간으로 바꾸려면 첫 번째 값은 360(6×60)이어야 합니다. 위 예시라면 결과는:",
            "advancedTitle": "고급 옵션(A/B/C 접미사)",
            "advancedOptionalHint": "이 섹션은 선택 사항입니다. 워치페이스가 A/B/C 형식 접미사를 지원할 때만 해당됩니다.",
            "advancedIntro": "워치페이스가 이 접미사를 지원하는지는 설정의 오프셋 필드 위 설명에 나와 있습니다. 지원하는 경우 다음과 비슷한 설명이 표시될 수 있습니다:",
            "advancedExample": "UTC 제2·제3 타임존 오프셋(분, 공백 구분)(오프셋 뒤 문자: A=12시간제, B=24시간제, C=군사 형식, 빈칸=기본)",
            "advancedNote": "이 선택 문자(A/B/C)는 일부 워치페이스에서 해당 타임존의 표시 형식을 제어합니다. 워치페이스 설명에 언급된 경우에만 사용하세요.",
            "exampleSectionTitle": "단계별: 다양한 도시와 형식 예시",
            "exampleIntro": "다음 예시는 제2 타임존(예: 뉴욕)과 제3 타임존(예: 도쿄)을 설정하고, 각 구역별로 12시간/24시간 표시를 선택하는 방법을 보여 줍니다.",
            "exampleStep1Title": "1단계: 제2 타임존 UTC 오프셋",
            "exampleStep1Text": "제2 타임존에 쓸 도시나 지역을 정한 뒤 UTC와의 시차를 분으로 환산하세요. 예: 뉴욕(EST, UTC−5) → −300분. 이 값을 필드의 첫 번째로 입력합니다.",
            "exampleStep2Title": "2단계: 제3 타임존 UTC 오프셋",
            "exampleStep2Text": "제3 타임존도 마찬가지입니다. 예: 도쿄(JST, UTC+9) → 540분. 두 번째 값이며 첫 번째와 공백으로 구분합니다.",
            "exampleOnlyOffsets": "워치페이스가 A/B/C 접미사를 사용하지 않으면 여기서 끝입니다. 입력:",
            "exampleStep3Title": "3단계: 선택 사항 형식 접미사(A/B/C)",
            "exampleStep3Optional": "이 단계는 선택 사항입니다. 워치페이스가 접미사를 지원해도 생략할 수 있으며, 그러면 기본 형식이 사용됩니다. 구역별로 12시간·24시간·군사 형식을 지정하려면 오프셋 바로 뒤에 문자를 붙이세요. 오프셋과 접미사 사이에 공백을 두지 마세요.",
            "exampleStep3Text": "예: 뉴욕 12시간 표시(A), 도쿄 24시간 표시(B):",
            "exampleStep3Note": "접미사 없음 = 워치페이스 기본(보통 24시간). 접미사 지원 여부는 워치페이스 설정의 오프셋 필드 위 설명에 나와 있습니다.",
            "exampleFormatTitle": "A, B, C로 시간이 표시되는 방식",
            "exampleFormatIntro": "같은 시각이라도 형식에 따라 표시가 달라집니다(예: 제2 구역 뉴욕 -300, 제3 구역 도쿄 540). 실시간 미리보기:",
            "zone2": "제2 구역",
            "zone3": "제3 구역",
            "exampleTableTitle": "참고: 일부 도시의 UTC 오프셋(분)",
            "exampleTableIntro": "표준시 기준. 서머타임은 다를 수 있습니다. 시간에 60을 곱하세요."
        },
        "switchViews": {
            "title": "전환 뷰 및 제스처 제어",
            "wordLabel": "전환 뷰",
            "basicsTitle": "전환 뷰란?",
            "basicsText": "많은 워치페이스가 같은 화면 영역에 다른 정보를 표시할 수 있습니다. 이 대체 페이지는 설정에서 \"Switchview\"({{wordLabel}}), \"Switchview 2\", \"상단 뷰 1/2\", \"하단 뷰 1/2\" 등으로 불리는 경우가 많습니다.",
            "proNote": "이 추가 뷰는 많은 경우 체험 기간에 사용 가능한 프로 기능이며 이후 활성화 키가 필요합니다.",
            "gestureTitle": "손목 제스처로 뷰 전환",
            "gestureIntro": "호환 터치스크린이 없는 워치에서는 두 번째 손목 움직임으로 대체 뷰를 전환할 수 있습니다.",
            "gestureStep1": "평소처럼 손목을 들어 디스플레이를 깨웁니다. 초 또는 밝아진 화면이 활성 모드임을 나타냅니다.",
            "gestureStep2": "몇 초 이내(약 7초)에 손목 움직임을 다시 합니다. 너무 급하지 않게, 워치가 인식할 수 있을 만큼 분명하게.",
            "gestureStep3": "워치페이스가 전환 뷰를 지원하면 설정한 영역(예: 상단/하단 뷰)이 다음 페이지로 바뀝니다.",
            "gestureHint": "아무것도 바뀌지 않으면 설정을 확인하세요. 일부 뷰는 명시적으로 할당해야 합니다(예: \"상단 뷰 2\" / \"하단 뷰 2\").",
            "touchTitle": "터치스크린 기기에서 전환 뷰",
            "touchIntro": "호환 터치스크린이 있는 최신 워치(예: Fenix 7 이상)에서는 특정 터치 영역을 눌러 뷰를 전환할 수 있는 경우가 많습니다.",
            "touchConfig": "많은 워치페이스에서 설정 아래쪽에서 이 영역을 구성할 수 있습니다. 시·분 숫자나 화면의 별도 영역이 일반적인 예입니다.",
            "touchHold": "터치 영역이 설정되어 있으면 해당 숫자/영역을 길게 누르면 할당된 뷰로 전환됩니다.",
            "touchMultiple": "일부 워치페이스는 상단 뷰용, 하단 뷰용 등 여러 영역을 따로 할당할 수 있습니다.",
            "touchInfo": "워치페이스에 특별한 영역이 있으면 이 웹사이트 또는 ConnectIQ 스토어의 안내 문구에 설명되어 있는 경우가 많습니다."
        },
        "findWfId": {
            "title": "WatchfaceID 찾는 방법",
            "whatIs": "WatchfaceID란?",
            "whatIsExplanation": "각 워치페이스에는 기기별 고유 WatchfaceID가 있습니다. 5~6자리 숫자입니다. 활성화 코드 구매 또는 지원 목적으로 필요합니다.",
            "connectIqTitle": "ConnectIQ 앱으로(권장)",
            "ciq1": "워치가 Bluetooth로 휴대폰에 연결되어 있는지 확인하세요.",
            "ciq2": "휴대폰에서 ConnectIQ 앱을 엽니다.",
            "ciq3": "설명과 이미지가 있는 워치페이스 페이지로 이동합니다. 찾지 못하면 하단 \"검색\" 바를 사용하거나 \"기기\"의 \"내 워치페이스\"를 확인하세요.",
            "ciq4": "워치페이스 페이지에서 \"설정\" 버튼을 눌러 모든 설정을 엽니다.",
            "ciq5": "WatchfaceID는 상단 필드에 표시됩니다. 이 번호를 복사하거나 입력하세요. 결제에 필요한 ID입니다.",
            "keyEntryTitle": "활성화 키 입력",
            "keyEntryExplanation": "WatchfaceID 필드 아래 줄에 결제 후 전송되는 키/코드용 필드가 있습니다. 일부 워치페이스는 남은 체험 일수를 표시합니다. 키를 입력하기 전에 삭제하세요.",
            "garminExpressTitle": "Garmin Express(데스크톱)로",
            "ge1": "Garmin Express를 설치하고 워치를 컴퓨터에 연결합니다.",
            "ge2": "설치된 워치페이스 목록으로 이동합니다.",
            "ge3": "워치페이스 항목 옆의 점 3개 버튼을 클릭하여 설정을 엽니다.",
            "ge4": "ConnectIQ 앱과 동일한 단계를 따릅니다.",
            "geNote": "참고: 일부 Garmin Express 버전에서 오류가 발생할 수 있어 ConnectIQ 앱 사용을 권장합니다.",
            "zeroId": "WatchfaceID가 0으로 표시됨?",
            "zeroIdExplanation": "WatchfaceID가 0으로 표시되는 경우가 있습니다. 보통 설정을 한 번 저장하거나 워치를 재시작하면 해결됩니다. 그래도 0이면 결제는 가능한 경우가 많습니다."
        },
        "location": {
            "title": "GPS 및 위치 설정",
            "whatIsGpsFix": "GPS 픽스란?",
            "gpsFixExplanation": "GPS 픽스로 워치페이스에 현재 위치를 알려 일출/일몰 시간, 달 위상, 날씨 위치, 조수를 올바르게 계산할 수 있습니다.",
            "howTo": "GPS 픽스 방법",
            "step1": "워치에서 활동(예: \"달리기\") 시작 화면으로 이동합니다",
            "step2": "워치가 GPS 신호를 잡을 때까지 기다립니다(녹색 막대/아이콘)",
            "step3": "워치페이스로 돌아갑니다. 몇 분 안에 데이터가 업데이트되어야 합니다",
            "alternative": "대안: 휴대폰 GPS",
            "alternativeExplanation": "휴대폰에서 GPS를 켤 수도 있습니다. 워치는 Bluetooth로 연결되어 있어야 합니다. 이 방법은 더 느리지만 동일하게 작동합니다.",
            "requirements": "요구 사항",
            "req1": "워치를 Bluetooth로 휴대폰에 연결",
            "req2": "Garmin Connect 앱(ConnectIQ 아님)이 최소한 백그라운드에서 실행",
            "req3": "휴대폰 기반 위치를 위해 휴대폰에서 GPS 사용"
        },
        "settings": {
            "tabs": { "options": "데이터 필드 옵션", "change": "설정 변경", "troubleshoot": "문제 해결" },
            "title": "워치페이스 설정",
            "optionsIntro": "데이터 필드 옵션 목록입니다. 클릭하면 설명이 표시됩니다. 모든 워치페이스에서 사용할 수 있는 것은 아닙니다.",
            "change": {
                "title": "워치페이스 설정 변경 방법",
                "intro": "워치페이스 설정은 휴대폰의 ConnectIQ 앱에서 변경할 수 있습니다.",
                "step1": "워치를 Bluetooth로 휴대폰에 연결하고 ConnectIQ 앱(Connect 아님)을 엽니다.",
                "step2": "워치페이스 페이지로 이동합니다. 설치되지 않았다면 먼저 설치하세요.",
                "step3": "워치페이스 페이지에서 \"설정\" 버튼을 탭하면 설정 목록이 열립니다.",
                "step4": "여기서 데이터 필드, 색상, 고급 옵션을 모두 변경할 수 있습니다.",
                "step5": "오른쪽 상단의 저장 버튼을 탭해 설정을 워치로 전송합니다.",
                "installLink": "설치 가이드"
            },
            "troubleshoot": {
                "title": "문제 해결",
                "cantSave": { "q": "설정을 저장할 수 없음", "a1": "Garmin 서버가 특정 문자를 처리하지 못하는 경우가 있습니다.", "a2": "색상 테마 필드(있는 경우)를 비운 뒤 다시 저장해 보세요." },
                "wontOpen": { "q": "설정이 열리지 않음", "a1": "ConnectIQ 앱을 완전히 종료하고 필요 시 워치를 재시작하세요.", "a2": "\"설치\" 버튼만 보인다면 워치페이스가 아직 설치되지 않은 것입니다." },
                "missingOptions": { "q": "특정 설정 옵션을 찾을 수 없음", "a": "모든 옵션이 모든 기기에서 사용 가능한 것은 아닙니다." },
                "naValue": { "q": "필드에 \"n/a\"만 표시됨", "a": "기기가 이 옵션을 지원하지 않습니다(구형 모델이거나 필요한 하드웨어가 없음)." }
            }
        },
        "dateFormat": {
            "title": "사용자 지정 날짜 형식 (날짜 1 / 2 / 3)",
            "basicsTitle": "날짜 형식 필드란?",
            "basicsIntro": "워치페이스 설정에는 날짜 1, 2, (선택 시) 3 표시 방식을 설정하는 필드가 2개(또는 3개) 있습니다. 입력한 문자에 따라 형식이 결정됩니다.",
            "notAll": "모든 워치페이스에서 사용할 수 있는 것은 아닙니다.",
            "where": "날짜 형식 설정 필드는 보통 설정 목록 아래쪽, 데이터 필드 옵션 아래에 있습니다.",
            "codesTitle": "형식 코드",
            "codesIntro": "형식 필드에 다음 문자를 사용할 수 있습니다. 결과는 현재 날짜를 반영합니다.",
            "codeD": "일(월 내, 앞에 0)",
            "codeDText": "요일(예: 월요일)",
            "codeM": "월(숫자, 앞에 0)",
            "codeMText": "월(텍스트)",
            "codeY": "연도 2자리",
            "codeY4": "연도 4자리",
            "codeJ": "율리우스일(군사)",
            "codeW": "주 번호",
            "codeO": "월(앞에 0 없음)",
            "codeN": "일(앞에 0 없음)",
            "codeP": "연중 일",
            "exampleHint": "예: \"D, d.M.Y\"는 \"월, 27.02.2026\"처럼 표시될 수 있습니다."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "테마는 어떻게 작동하나요?:",
            "description": "워치페이스 설정 상단에 현재 색상 설정(아이콘, 차트, 시간 등)을 나타내는 \"테마 문자열\"이 있습니다. 무언가(예: 상단 섹션 색상)를 바꾸고 \"저장\"을 누르면 다음에 설정을 열 때 테마 문자열이 갱신됩니다. 이렇게 테마 문자열을 복사해 다른 곳에 저장하면 색상 설정을 보관할 수 있습니다. 리뷰나 포럼에서 다른 사람과 공유하거나, 다른 사람의 테마 문자열을 적용해 다른 스타일을 시험해 볼 수도 있습니다."
        },
        "dynamicThemeSwitching": {
            "title": "동적 테마 전환:",
            "sunset": {
                "title": "일몰 후 / 일출 전 전환 -",
                "description": "테마 문자열 필드에서 전환하려는 테마 문자열 앞에 느낌표 ! 를 넣으면 일몰 후 전환할 테마로 저장됩니다(예: !UEUE[UEUEEEEEEU^). 언제든 선두에 ! 가 있는 테마 문자열을 필드에 넣어 변경할 수 있습니다. 야간 테마를 제거하려면 필드에 ! 만 넣으면 더 이상 전환되지 않습니다."
            },
            "lowPower": {
                "title": "절전 모드에서 전환 -",
                "description": "위의 일몰/일출 테마 설정과 같은 과정이지만, ! 대신 테마 문자열 앞에 # 을 넣습니다(예: #UEUE[UEUEEEEEEU^). 워치는 화면을 보거나 메뉴에서 돌아온 후 약 10초 뒤 \"절전 모드\"에 들어갑니다. 보통 절전 모드에서는 초가 사라집니다(워치페이스 설정에서 변경 가능). 두 전환 옵션(@밤/@절전)을 함께 사용할 수 있습니다. 한 번 설정하면 동적 테마 문자열은 워치페이스 설정에 보이지 않으므로 나중에 수정할 수 있도록 다른 곳에 저장해 두세요."
            }
        }
    },
    "helpCenter": {
        "title": "도움말 및 설명",
        "subtitle": "워치페이스에 대한 답변, 가이드 및 설명",
        "guidesTitle": "가이드 및 설명",
        "faqTitle": "자주 묻는 질문",
        "allCategories": "전체",
        "guides": "가이드",
        "faqResults": "FAQ",
        "noResults": "결과를 찾을 수 없습니다",
        "noResultsHint": "다른 키워드를 시도하거나 아래 카테고리와 가이드를 탐색하세요."
    },
    "watchfacesOverview": {
        "title": "모든 앱",
        "loading": "워치페이스 로딩 중...",
        "error": "워치페이스 로딩 오류",
        "retry": "다시 시도",
        "noWatchfaces": "사용 가능한 워치페이스가 없습니다"
    },
    "detailTabs": {
        "payment": "결제",
        "themes": "테마",
        "info": "정보",
        "instructions": "설명",
        "instructionsIntro": "모든 가이드와 설명 한눈에:",
        "noThemes": "이 워치페이스에는 색상 테마가 없습니다."
    },
    "watchfaceDetail": {
        "loading": "워치페이스 로딩 중...",
        "error": {
            "notFound": "워치페이스를 찾을 수 없습니다",
            "loading": "워치페이스 로딩 오류"
        },
        "backToOverview": "목록으로 돌아가기",
        "goToStore": "IQ Store로",
        "goToTrial": "체험판",
        "devices": "기기",
        "info": {
            "title": "기능",
            "tides": "🌊 조수 정보(자동 업데이트)",
            "weather": "🌤️ OpenWeatherMap 및 Yr 날씨 데이터",
            "colors": "🎨 색상 테마 및 맞춤 설정",
            "location": "📍 GPS 기반 위치",
            "faq": "❓ FAQ 및 지원",
            "weatherFallback": "One Call 3.0 구독 없이 OpenWeatherMap API 키를 사용하면 \"Yr\" 공급자로 폴백됩니다."
        }
    },
    "colorThemes": {
        "clickToCopy": "클릭하여 복사",
        "clickToPreview": "클릭하여 미리보기",
        "closePreview": "미리보기 닫기",
        "copied": "복사됨!",
        "useInSettings": "워치페이스 설정에서 사용",
        "guideLink": "테마 및 테마 문자열 자세히",
        "deviceNote": "색상 테마는 모든 기기에서 사용할 수 있는 것은 아닙니다.",
        "noFieldNote": "워치페이스 설정에 색상 테마용 별도 필드가 없다면, 이 워치페이스에서 해당 시계 모델에 대해 색상 테마가 지원되지 않는 것입니다."
    },
    "payment": {
        "option1": {
            "title": "옵션 1: Garmin Pay",
            "description": "ConnectIQ Store에서 Garmin Pay로 유료 워치페이스 구매(지원 시계인 경우).",
            "link": "ConnectIQ Store 링크"
        },
        "option2": {
            "title": "옵션 2: WatchfaceID로 직접 결제",
            "description": "시계가 Pro 버전을 지원하지 않으면 WatchfaceID를 입력하여 체험/VX 버전 키를 구매할 수 있습니다.",
            "vxNote": "이 키는 워치페이스 VX 버전용이며 Garmin Pay 버전용이 아닙니다!",
            "vxLink": "VX 버전 링크"
        },
        "tax": "세금",
        "wfid": {
            "description": "WatchfaceID 입력(워치페이스 설정에서 확인)",
            "placeholder": "WatchfaceID 입력(5-6자리)",
            "guideLink": "WatchfaceID 찾는 방법",
            "guideLinkShort": "설명 보기"
        },
        "wfidError": {
            "letters": "WatchfaceID는 숫자만 입력하세요",
            "tooLong": "WatchfaceID는 5-6자리여야 합니다",
            "invalid": "올바른 WatchfaceID를 입력하세요(5-6자리)",
            "lengthHint": "WatchfaceID는 보통 5-6자리입니다. 확인하세요."
        },
        "errors": {
            "empty": "WatchfaceID를 입력하세요",
            "invalid": "올바른 WatchfaceID를 입력하세요",
            "config": "결제 설정 오류",
            "checkout": "결제를 열 수 없습니다. 다시 시도하세요."
        },
        "buy": "지금 구매",
        "selectMethod": "버전 선택",
        "versionSelectHint": "이것은 두 개의 별도 버전입니다 — 올바른 버전을 선택하세요:",
        "vxWarning": "VX 및 Elite 버전은 각각 별도로 다운로드 가능한 워치페이스 버전입니다. VX 버전의 활성화 코드로는 Elite 버전이 잠금 해제되지 않습니다.",
        "beta": {
            "title": "현재 베타",
            "description": "베타 기간 동안 이 워치페이스는 완전히 무료로 사용할 수 있습니다. 테스트 기간이 끝난 뒤에도 자동으로 비용이 청구되지는 않습니다. 이 기간 동안 새로운 기능과 개선 사항을 테스트하고 있습니다. 피드백에 감사드립니다!",
            "descriptionApp": "이 베타 기간 동안 이 앱을 완전히 무료로 사용할 수 있습니다. 테스트 기간이 끝난 후에도 자동 요금이 청구되지 않습니다. 이 기간 동안 새로운 기능과 개선 사항을 테스트합니다. 피드백 감사합니다!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Elite 버전",
            "description": "이 워치페이스는 ConnectIQ Store의 Garmin Pay를 통해서만 구매할 수 있습니다.",
            "comboDescription": "ConnectIQ Store에서 Garmin Pay로 구매. 별도 독립 버전입니다.",
            "compatibility": "Garmin Pay는 모든 시계에서 지원되지 않습니다. Store 페이지에서 호환성을 확인하세요. 그렇지 않으면 VX 버전(기술적으로 동일)을 다운로드하세요.",
            "storeLink": "ConnectIQ Store에서 열기",
            "moreGuide": "Elite와 VX 버전 차이에 대해 자세히",
            "moreGuideLink": "구매 및 설치 가이드 읽기",
            "eliteNoKey": "Garmin Pay로 Elite 버전을 구매해도 잠금 해제 코드가 발송되지 않습니다. Elite 버전은 구매 후 바로 잠금 해제되며 코드가 필요하지 않습니다.",
            "accountBound": "Garmin Pay를 통한 구매는 Garmin 계정에 연결되며 향후 기기에서도 자동으로 사용할 수 있습니다(호환되는 경우).",
            "eliteNoKeyAndGuide": "Garmin Pay로 구매 시 잠금 해제 코드가 발송되지 않습니다 — Elite 버전은 구매 후 바로 잠금 해제됩니다. 자세한 내용은 구매 및 설치 가이드를 참조하세요."
        },
        "vx": {
            "badge": "모든 기기",
            "title": "VX 버전",
            "description": "지원되는 모든 기기와 호환. ConnectIQ Store에서 무료 체험판을 다운로드한 후 여기서 구매한 코드로 활성화.",
            "trialNote": "VX 버전에는 체험 기간이 포함됩니다. 이후 아래에서 활성화 코드를 구매하여 잠금 해제.",
            "deviceBound": "활성화 코드는 기기에 연결되며 VX 버전을 영구적으로 잠금 해제합니다.",
            "moreGuide": "VX 버전, 키 또는 설치에 대해 자세히",
            "moreGuideLink": "구매 및 설치 가이드 읽기",
            "downloadLink": "VX 버전 다운로드",
            "details": {
                "line1": "결제 완료 후 활성화 키가 다음 단계에서 입력한 이메일로 전송됩니다.",
                "line2": "이메일 주소가 올바른지 확인하세요.",
                "line3": "결제 후 스팸 폴더를 확인하세요. 키 이메일은 자주 그곳에 들어갑니다.",
                "line4": "모든 결제는 Paddle이 처리합니다. 계정 불필요.",
                "line5": "지원 요청은 문의 양식 또는 ConnectIQ Store 도구를 사용하세요.",
                "line6": "기타 문의는 처리할 수 없습니다."
            }
        },
        "standalone": {
            "title": "활성화 코드 구매",
            "description": "아래에 WatchfaceID를 입력하여 활성화 코드를 구매하세요. 코드가 즉시 전송됩니다."
        },
        "checkoutOpening": "결제 열기 중...",
        "info": {
            "key": "구매 후 워치페이스 설정에 입력할 키를 받게 됩니다.",
            "activation": "키는 결제 완료 후 즉시 활성화됩니다.",
            "support": "문의 사항이 있으면 지원팀에 연락하세요.",
            "moreGuide": "구매 및 설치 자세히"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "신용 카드"
        }
    },
    "footer": {
        "tagline": "모든 활동을 위한 고급 기능을 갖춘 현대적인 Garmin 앱.",
        "description": "모든 활동을 위한 고급 기능을 갖춘 현대적인 Garmin 앱."
    },
    "newsletter": {
        "title": "뉴스레터",
        "description": "새 워치페이스, 기능, 프로모션 소식을 받으려면 뉴스레터를 구독하세요.",
        "frequencyHint": "대략 2개월에 한 번 이메일. 언제든 구독 해지 가능.",
        "emailPlaceholder": "이메일 주소",
        "subscribe": "구독",
        "unsubscribe": "구독 해지",
        "subscribeSuccess": "구독 완료! 이메일을 확인해 주세요.",
        "subscribeError": "오류가 발생했습니다. 나중에 다시 시도해 주세요.",
        "unsubscribeSuccess": "구독 해지되었습니다.",
        "unsubscribeError": "오류가 발생했습니다. 나중에 다시 시도해 주세요."
    },
    "contact": {
        "title": "문의",
        "description": "질문이 있거나 도움이 필요하신가요? 저에게 메시지를 보내주세요.",
        "emailLabel": "이메일",
        "emailPlaceholder": "you@email.kr",
        "deviceLabel": "기기 (선택 사항)",
        "devicePlaceholder": "예: Fenix 7",
        "watchfaceLabel": "워치페이스 (선택 사항)",
        "watchfacePlaceholder": "예: Horizon",
        "messageLabel": "메시지",
        "messagePlaceholder": "메시지를 입력하세요...",
        "send": "메시지 보내기",
        "sendAnother": "다른 메시지 보내기",
        "successTitle": "메시지가 전송되었습니다!",
        "successMessage": "가능한 한 빨리 답변드리겠습니다.",
        "error": "오류가 발생했습니다. 다시 시도하거나 dev@orcatec.net 으로 직접 메일을 보내주세요.",
        "rateLimit": "5분당 최대 2통까지 보낼 수 있습니다. 나중에 다시 시도해 주세요.",
        "consentNotice": "이 양식을 제출하면, 귀하의 데이터가 다음 약관에 따라 처리되는 것에 동의하게 됩니다:",
        "guidesIntro": "특정 기능에 대한 질문이라면, 아래 안내 문서에서 이미 답을 찾을 수 있을지도 모릅니다:",
        "faqIntro": "많은 주제에 대해 자세한 FAQ도 준비되어 있습니다:",
        "faqLinkLabel": "도움말 및 설명 열기",
        "responseTimeNotice": "바쁜 시기에는 답변까지 며칠이 걸릴 수 있다는 점 양해 부탁드립니다."
    },
    "fonts": {
        "title": "글꼴",
        "timefonts": "시간 글꼴",
        "datafonts": "데이터 글꼴"
    },
    "common": {
        "loading": "로딩 중...",
        "error": "오류",
        "retry": "다시 시도",
        "back": "뒤로",
        "close": "닫기",
        "save": "저장",
        "cancel": "취소",
        "confirm": "확인",
        "notFound": "404 – 페이지를 찾을 수 없습니다"
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Bierwandern 앱으로 하이킹과 길에서 즐기는 리필을 기록할 수 있습니다. 추가로 혈중 알코올 추정치와 차트(대략적인 추정)도 제공됩니다 – 너무 진지하게 받아들이지 마세요!",
        "settingsHint": "시작 화면에서 시계의 메뉴 버튼을 눌러 설정 메뉴로 들어갑니다(2버튼 레이아웃 시계는 터치스크린을 길게 누르세요).",
        "disclaimer": "프로밀 계산은 순전히 재미용 지표입니다 – 마신 음료와 체중을 바탕으로 혈중 알코올 농도를 추정하는 알고리즘입니다! 이 값을 근거로 결정을 내리지 마세요 – 신뢰할 수 없으며 실제 알코올 측정이 아닙니다!",
        "closing": "그 외에는 즐거운 하이킹과 좋은 시간 되시길 바랍니다!",
        "support": "문제나 개선 제안이 있으면 «App Support» 버튼을 이용해 주세요 – 감사합니다."
    },
    "bodysurf": {
        "intro": {
            "title": "BodySurf란?",
            "text": "BodySurf는 보디서핑용 Garmin Connect IQ 시계 앱입니다. GPS로 파도 타기를 감지하고 각 라이드의 거리와 시간을 측정하며, 주행 거리에 따라 재미있는 타이틀을 부여합니다. 세션은 Garmin Connect에서 개별 랩이 있는 활동으로 저장됩니다."
        },
        "gps": {
            "title": "시작 전 – GPS",
            "text1": "세션 시작 전 GPS 고정을 기다리세요. 시작 화면에서 신호가 잡힐 때까지 \"GPS 검색 중\", 이후 \"시작하려면 START\"이 표시됩니다.",
            "text2": "최상의 정확도를 위해 지원 시계에서는 멀티 GNSS / 듀얼 밴드 GPS를 사용합니다. 고정이 오래 걸리면 물가에서 잠시 정지하세요."
        },
        "start": {
            "title": "시작 화면",
            "startBtn": "GPS 준비 후 새 세션 시작 (START = 세션 시작).",
            "menuBtn": "설정 열기: 사용 방법 및 단위 (MENU = 설정 / 정보).",
            "backBtn": "BACK = 앱 종료"
        },
        "during": {
            "title": "활동 중",
            "detect": "주행은 GPS로 감지됩니다 속도 자동으로. BACK를 사용하세요 수동으로 주행을 시작/중지합니다. 약 2m 미만의 짧은 움직임은 무시됩니다.",
            "startBtn": "START = 정지 / 저장 / 재개",
            "backBtn": "BACK = 수동 주행 켜기/끄기",
            "live": "라이드 중 현재 거리, 라이브 타이틀, \"타고 있습니다!\"이 표시됩니다. 라이드 종료 후 다음 라이드까지 타이틀과 통계가 유지됩니다."
        },
        "stop": {
            "title": "중지 메뉴",
            "resume": "재개",
            "save": "저장",
            "discard": "버리기"
        },
        "after": {
            "title": "세션 후",
            "summary": "요약에 세션 시간, 주행 수, 총 거리, 최고 라이드 타이틀과 통계가 표시됩니다.",
            "rides": "스와이프하여 주행 세부정보 보기. 버튼 시계: << DOWN rides.",
            "finished": "이후: START로 새 세션, BACK으로 앱 종료."
        },
        "titles": {
            "title": "라이드 타이틀",
            "intro": "각 주행은 재미있는 제목을 가집니다 거리 기반. 더 길수록 제목이 더 좋습니다!",
            "colDistance": "거리",
            "colTitle": "타이틀",
            "th0": "바다오이",
            "th1": "광어",
            "th2": "인간 서핑보드",
            "th3": "파도타기",
            "th4": "아쿠아맨",
            "th5": "포세이돈",
            "th6": "넵튠",
            "th7": "파도 정복자",
            "th8": "마스터 라이더",
            "th9": "파도 신",
            "th10": "바다 전설",
            "th11": "파도의 타이탄",
            "th12": "바다의 왕"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "저장된 세션은 Garmin Connect에 라이드 타이틀, 랩 거리(미터), 랩 시간(초), 최장 라이드/시간 등 사용자 필드와 함께 표시됩니다. 감지된 각 라이드는 랩으로 저장됩니다."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "Instinct에서는 서브 디스플레이에 시간, GPS, 라이드 거리 표시. 스와이프 대신 DOWN 버튼 (<< DOWN rides).",
            "menu": "시작 화면 왼쪽에 \"메뉴\". 서브 디스플레이에 GPS OK일 때 START를 눌러주세요."
        },
        "settings": {
            "title": "설정",
            "units": "단위: 시계에서 거리·속도의 미터법/야드파운드법 전환.",
            "info": "정보: 시계 내 도움말 (사용 방법) – 활동 중, 세션 후, 시작 화면 버튼."
        },
        "supportBefore": "문제나 제안이 있으면",
        "supportLink": "문의 양식",
        "supportAfter": "을 이용해 주세요."
    }
};
